const logos = {
  artica: require("./artica.png"),
  att: require("./att.png"),
  bacardi: require("./bacardi.png"),
  bny: require("./bny.png"),
  espn: require("./espn.png"),
  intel: require("./intel.png"),
  merck: require("./merck.png"),
  metlife: require("./metlife.png"),
  novartis: require("./novartis.png"),
  pedigree: require("./pedigree.png"),
  pep: require("./pep.png"),
  rubraca: require("./rubraca.png"),
  samsung: require("./samsung.png"),
  sap: require("./sap.png"),
  say: require("./say.png"),
  shp: require("./shp.png"),
  spectrum: require("./spectrum.png"),
  ted: require("./ted.png"),
  uniqlo: require("./uniqlo.png"),
  winston: require("./winston.png"),
  yamaha: require("./yamaha.png"),
};

export default logos;
